// eslint-disable-next-line no-restricted-imports
import styled from '@emotion/styled';

import { useIpadMediaQuery } from '@jane/kiosk/hooks';

export const TitleSearchField = styled.div(({ theme }) => {
  const isIpad = useIpadMediaQuery();
  const titleTypography = theme.components.Typography.variants['h2-regular'];
  const headerTypography = theme.components.Typography.variants['h3-regular'];
  const lineHeight = isIpad
    ? headerTypography['mobileStyles']?.lineHeight
    : titleTypography['desktopStyles']?.lineHeight;
  const fontSize = isIpad
    ? headerTypography['mobileStyles']?.fontSize
    : titleTypography['desktopStyles']?.fontSize;
  const fontWeight = titleTypography.fontWeight;
  const height = isIpad ? '56px' : '80px';
  return {
    ':focus-within': {
      borderColor: theme.colors.primary.main,
    },
    alignItems: 'center',
    backgroundColor: 'white',
    borderColor: 'transparent',
    borderRadius: '50px',
    borderStyle: 'solid',
    borderWidth: '2px',
    boxShadow: '0px 4px 48px rgba(0, 0, 0, 0.05)',
    display: 'flex',
    flexDirection: 'row',
    flexGrow: 1,
    input: {
      '::placeholder': {
        color: theme.colors.grays.light,
      },
      ':focus': {
        color: theme.colors.grays.black,
      },
      borderRadius: '50px',
      borderWidth: 0,
      color: theme.colors.grays.mid,
      fontSize,
      fontWeight,
      lineHeight,
    },
    height,
    marginRight: '24px',
    paddingLeft: isIpad ? '24px' : '40px',
    paddingRight: isIpad ? '16px' : '24px',
    zIndex: 2,
  };
});
